import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../_helpers/api';
import { Detail } from 'Components/Common/Detail/Detail';
import { Identificacion } from 'Components/Common/Detail/Identificacion';
import { Emisor } from 'Components/Common/Detail/Emisor';
import { Receptor } from 'Components/Common/Detail/Receptor';
import { Resumen } from 'Components/Common/Detail/Resumen';
import { LoadingPlaceholder } from 'Components/Common/LoadingPlaceholder';

export const NCEDetail = () => {
  let { codigoGeneracion } = useParams();

  const [dte, setDTE] = useState({});
  const [loading, setLoading] = useState(true);
  
  const getDetails = () => {
    api.get(`${api.getUri()}NCE/DTE/${codigoGeneracion}`).then((response) => {
      const responseDte = response.data.pop();
      setDTE(responseDte);      
      setLoading(false);
    });
  };

  const onRefresh = () => {
    getDetails();
  }

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoGeneracion]);

  return (
    <div>
      {loading ? (<LoadingPlaceholder />) : (
        <Detail
          loading={loading}
          dte={dte}
          dteType={'NCE'}
          onRefresh={onRefresh}
          title={`DTE: Nota de Crédito Electrónica (NCE): ${loading ? '' : dte.dte.identificacion.codigoGeneracion}`}
        >
          <Identificacion identificacion={dte.dte.identificacion} firma={dte.firma} estatus={dte.estatus} validationResult={dte.validationResult} otherValidationsResult={dte.otherValidationsResult}/> 
          <Emisor emisor={dte.dte.emisor} codigoGeneracion={dte.dte.identificacion.codigoGeneracion}/> 
          <Receptor receptor={dte.dte.receptor} codigoGeneracion={dte.dte.identificacion.codigoGeneracion} />
          <Resumen resumen={dte.dte.resumen} codigoGeneracion={dte.dte.identificacion.codigoGeneracion}/>
        </Detail>
      )}    
    </div>
  );
};
